import React from "react";

function AppleGlyph() {
  return (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="currentColor" aria-hidden="true">
      <path d="M17.05 14.6c-.03-3.13 2.55-4.64 2.67-4.71-1.46-2.13-3.72-2.42-4.52-2.45-1.92-.2-3.75 1.13-4.72 1.13-.99 0-2.49-1.11-4.1-1.08-2.1.03-4.05 1.23-5.13 3.12-2.19 3.8-.56 9.4 1.56 12.48 1.04 1.5 2.27 3.19 3.88 3.13 1.56-.06 2.15-1.01 4.03-1.01s2.42 1.01 4.07.97c1.68-.03 2.74-1.52 3.76-3.04 1.2-1.74 1.69-3.43 1.72-3.52-.04-.02-3.3-1.27-3.33-5.02zm-3.1-9.25c.85-1.05 1.43-2.49 1.27-3.94-1.23.05-2.74.83-3.63 1.87-.79.92-1.49 2.4-1.3 3.81 1.38.1 2.8-.7 3.66-1.74z"/>
    </svg>
  );
}

function PlayGlyph() {
  return (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" aria-hidden="true">
      <path d="M3 2.5v23l12-11.5L3 2.5z" fill="#00e5ff"/>
      <path d="M3 2.5l12 11.5L18.5 10.5 5 3 3 2.5z" fill="#00ff9d" opacity="0.9"/>
      <path d="M3 25.5l12-11.5L18.5 17.5 5 25l-2 .5z" fill="#ffd600" opacity="0.9"/>
      <path d="M18.5 10.5l3.5 2c1 .6 1 2.4 0 3l-3.5 2L15 14l3.5-3.5z" fill="#ff3d00"/>
    </svg>
  );
}

export function StoreBadge({ kind, onClick, labels }) {
  const isIOS = kind === "ios";
  const tiny = labels?.tiny ?? (isIOS ? "Download on the" : "GET IT ON");
  const name = labels?.name ?? (isIOS ? "App Store" : "Google Play");
  const soon = labels?.soon ?? "SOON";
  const aria = labels?.aria ?? `${name} — coming soon`;
  return (
    <button
      type="button"
      className="cmd-store-badge"
      aria-label={aria}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(kind);
      }}
    >
      {isIOS ? <AppleGlyph /> : <PlayGlyph />}
      <span className="cmd-store-badge__labels">
        <span className="cmd-store-badge__tiny">{tiny}</span>
        <span className="cmd-store-badge__name">{name}</span>
      </span>
      <span className="cmd-soon-pill">{soon}</span>
    </button>
  );
}

export default function StoreBadges({ onClick, iosLabels, androidLabels, compact = false }) {
  return (
    <div className={compact ? "cmd-store-row cmd-store-row--compact" : "cmd-store-row"}>
      <StoreBadge kind="ios"     onClick={onClick} labels={iosLabels} />
      <StoreBadge kind="android" onClick={onClick} labels={androidLabels} />
    </div>
  );
}
